import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_on_delivery.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-9ad9fb16")

_pushScopeId("data-v-9ad9fb16")
const _hoisted_1 = { class: "flex justify-between" }
const _hoisted_2 = { class: "flex flex-row gap-2 items-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-6"
}, null, -1)
const _hoisted_4 = { class: "text-black-lp-300 text-14px font-semibold whitespace-nowrap px-1" }
const _hoisted_5 = { class: "flex gap-1 items-center bg-green-lp-500 rounded-md px-2 py-1 text-green-lp-200" }
const _hoisted_6 = /*#__PURE__*/_createVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.69394 5.0342C7.60255 4.94229 7.48935 4.87541 7.36507 4.83992C7.2408 4.80442 7.10958 4.80149 6.98386 4.83138C6.85814 4.86128 6.74209 4.92302 6.64673 5.01075C6.55137 5.09848 6.47986 5.20928 6.43898 5.33264L4.35041 11.6383L2.33315 13.6692C1.90661 14.0986 1.66699 14.6809 1.66699 15.2882C1.66699 15.8955 1.90661 16.4779 2.33315 16.9073C2.75968 17.3367 3.33818 17.5779 3.94139 17.5779C4.54459 17.5779 5.12309 17.3367 5.54962 16.9073L5.69973 16.7562L9.49892 18.6693C9.64128 18.741 9.80245 18.7658 9.95957 18.7401C10.1167 18.7145 10.2618 18.6397 10.3743 18.5263L10.9104 17.9866C11.0526 17.8435 11.1325 17.6494 11.1325 17.447C11.1325 17.2445 11.0526 17.0504 10.9104 16.9073L8.56132 14.5424L13.8304 12.7738C13.953 12.7327 14.063 12.6607 14.1502 12.5647C14.2373 12.4687 14.2987 12.3518 14.3284 12.2253C14.3581 12.0987 14.3551 11.9666 14.3199 11.8415C14.2846 11.7164 14.2182 11.6024 14.1269 11.5104L7.69394 5.0342Z",
    fill: "#006644"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M13.4746 6.14186C13.1785 5.84381 13.1785 5.36057 13.4746 5.06252L15.0827 3.44352C15.3788 3.14547 15.8588 3.14547 16.1549 3.44352C16.4509 3.74157 16.4509 4.22481 16.1549 4.52286L14.5467 6.14186C14.2506 6.43991 13.7706 6.43991 13.4746 6.14186Z",
    fill: "#006644"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M10.3022 4.96219C9.89773 4.8531 9.65773 4.4346 9.76609 4.02746L10.3547 1.81586C10.4631 1.40872 10.8788 1.1671 11.2832 1.27619C11.6876 1.38529 11.9276 1.80378 11.8193 2.21093L11.2306 4.42252C11.1223 4.82967 10.7066 5.07128 10.3022 4.96219Z",
    fill: "#006644"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M14.6463 9.33552C14.5379 8.92838 14.7779 8.50988 15.1823 8.40079L17.3792 7.8082C17.7836 7.6991 18.1993 7.94072 18.3076 8.34786C18.416 8.75501 18.176 9.1735 17.7716 9.28259L15.5748 9.87519C15.1703 9.98428 14.7546 9.74267 14.6463 9.33552Z",
    fill: "#006644"
  })
], -1)
const _hoisted_7 = { class: "text-12px cursor-pointer" }
const _hoisted_8 = { class: "font-normal" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-row gap-2 items-center"
}
const _hoisted_10 = { class: "text-black-lp-300 text-12px font-semibold whitespace-nowrap px-1" }
const _hoisted_11 = {
  key: 0,
  class: "h-full w-full grid grid-cols-5 gap-2.5 place-content-start"
}
const _hoisted_12 = {
  key: 1,
  class: "h-full w-full grid grid-cols-5 gap-2.5 place-content-start product-container"
}
const _hoisted_13 = { class: "mt-3 text-10px" }
const _hoisted_14 = { class: "font-semibold flex items-center" }
const _hoisted_15 = {
  key: 0,
  class: "flex items-center gap-1 ml-1"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "dot-small rounded-full bg-gray-lp-800" }, null, -1)
const _hoisted_17 = {
  key: 0,
  class: "text-gray-lp-600 font-semibold text-12px"
}
const _hoisted_18 = {
  key: 1,
  class: "text-gray-lp-600 font-semibold text-12px"
}
const _hoisted_19 = {
  key: 2,
  class: "font-semibold text-black-lp-100"
}
const _hoisted_20 = { class: "w-full mt-4 rounded-b-md font-medium text-10px" }
const _hoisted_21 = {
  key: 0,
  class: "inline-block align-middle"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("b", { class: "flex items-center gap-custom" }, [
  /*#__PURE__*/_createVNode("div", { class: "dot rounded-full bg-gray-lp-600" }),
  /*#__PURE__*/_createVNode("div", { class: "dot rounded-full bg-gray-lp-600" }),
  /*#__PURE__*/_createTextVNode(" % ")
], -1)
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_25 = { class: "flex items-center gap-custom" }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  class: "absolute right-0 top-0 rounded-tr-lg",
  width: "62",
  height: "44",
  viewBox: "0 0 62 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 45 45",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M19.2679 7.71456C20.59 4.92848 24.41 4.92848 25.7321 7.71456L28.9932 14.5865L36.285 15.6885C39.2414 16.1353 40.4218 19.9137 38.2826 22.0824L33.0061 27.4314L34.2517 34.9845C34.7567 38.0467 31.6663 40.3819 29.0221 38.9361L22.5 35.37L15.9779 38.9361C13.3337 40.3819 10.2433 38.0467 10.7483 34.9845L11.9939 27.4314L6.7174 22.0824C4.57818 19.9137 5.75863 16.1353 8.71496 15.6885L16.0069 14.5865L19.2679 7.71456Z",
    fill: "#FFFFFF"
  })
], -1)
const _hoisted_29 = {
  key: 2,
  class: "h-96 flex items-center justify-center"
}
const _hoisted_30 = { class: "p-3 text-center" }
const _hoisted_31 = { class: "text-14px text-gray-lp-300 font-semibold" }
const _hoisted_32 = { class: "text-12px text-gray-lp-300 mt-2" }
const _hoisted_33 = { class: "p-3" }
const _hoisted_34 = { class: "flex flex-row items-center justify-center" }
const _hoisted_35 = {
  key: 3,
  class: "flex text-red-lp-100 gap-1 mt-2"
}
const _hoisted_36 = { class: "text-14px" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_ToggleV2 = _resolveComponent("ToggleV2")!
  const _component_skeleton = _resolveComponent("skeleton")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Icons = _resolveComponent("Icons")!

  return (_openBlock(), _createBlock("section", {
    style: _ctx.fullHeight ? '' : 'height: max-content;',
    class: ["bg-white flex flex-col gap-2 rounded-xl p-3", {
      'h-full': _ctx.fullHeight
    }]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("bookingV3.productType.title")), 1),
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode("span", _hoisted_7, [
            _createTextVNode(_toDisplayString(_ctx.$t("bookingV3.productType.info.infoPrice")) + " ", 1),
            _createVNode("b", {
              onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onOpenTooltip($event))),
              onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onOpenTooltip($event))),
              class: "underline"
            }, _toDisplayString(_ctx.$t("bookingV3.productType.info.otherPrice")), 33),
            _createTextVNode(_toDisplayString(_ctx.$t("bookingV3.productType.info.infoTariff")), 1)
          ]),
          _createVNode(_component_OverlayPanel, {
            ref: "openTooltip",
            appendTo: "body",
            class: "w-1/4 p-2",
            style: {
              backgroundColor: '#4D4D4D',
              color: '#ffffff',
              fontSize: '12px'
            }
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", null, _toDisplayString(_ctx.$t("bookingV3.productType.tooltip.title")), 1),
                _createVNode("div", {
                  innerHTML: _ctx.$t('bookingV3.productType.tooltip.priceMsg')
                }, null, 8, ["innerHTML"])
              ])
            ]),
            _: 1
          }, 512)
        ])
      ]),
      (_ctx.isBookingRetail)
        ? (_openBlock(), _createBlock("div", _hoisted_9, [
            _createVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("bookingV3.productType.titleToggle")), 1),
            _createVNode(_component_ToggleV2, {
              onClick: _cache[3] || (_cache[3] = () => _ctx.toggleReturnConfig()),
              "style-active": _ctx.toggle - _ctx.active,
              "model-value": _ctx.isDiscountAgentHide
            }, null, 8, ["style-active", "model-value"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isLoadingUpselling)
      ? (_openBlock(), _createBlock("div", _hoisted_11, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listProduct, (product) => {
            return (_openBlock(), _createBlock(_component_skeleton, {
              width: "100%",
              height: "132px",
              key: product
            }))
          }), 128))
        ]))
      : (!_ctx.isLoadingUpselling && !_ctx.isErrorUpselling)
        ? (_openBlock(), _createBlock("div", _hoisted_12, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getListProduct, (product, index) => {
              return (_openBlock(), _createBlock("label", {
                id: `button_product_poster_${product.name.toLowerCase()}`,
                key: index,
                class: [
          'relative p-2 h-full block overflow-hidden rounded-lg',
          _ctx.cardActiveValidation(product.statusActive, product.isEmbargo)
            ? 'bg-gray-lp-1200'
            : 'bg-white cursor-pointer',
          new RegExp(`^${_ctx.activeProducts}$`, 'i').test(product.name) &&
          !_ctx.cardActiveValidation(product.statusActive, product.isEmbargo, true)
            ? 'label-border-selected'
            : 'border border-gray-lp-400'
        ],
                style: {"height":"132px"},
                onClick: ($event: any) => (
          _ctx.cardActiveValidation(product.statusActive, product.isEmbargo)
            ? () => {}
            : _ctx.setProduct(product.name)
        )
              }, [
                _createVNode("input", {
                  type: "radio",
                  name: `product-selection-${_ctx.id}`,
                  value: product.name,
                  checked: new RegExp(`^${_ctx.activeProducts}$`, 'i').test(product.name),
                  id: `product-${product.name.toLowerCase()}-${_ctx.id}`,
                  onChange: 
            () =>
              _ctx.cardActiveValidation(product.statusActive, product.isEmbargo)
                ? {}
                : _ctx.setProduct(product.name)
          ,
                  class: "z-10 absolute opacity-0",
                  disabled: 
            _ctx.cardActiveValidation(product.statusActive, product.isEmbargo)
          
                }, null, 40, ["name", "value", "checked", "id", "onChange", "disabled"]),
                _createVNode("div", null, [
                  _createVNode("img", {
                    class: "text-gray-lp-600",
                    alt: "products-cards",
                    src: 
              require(`@/app/ui/assets/svg/product-logo-v3/${
                _ctx.cardActiveValidation(product.statusActive, product.isEmbargo)
                  ? _ctx.productTypeAsset(product.name).imageInactive
                  : _ctx.productTypeAsset(product.name).imageActive
              }.svg`)
            ,
                    height: "22.4"
                  }, null, 8, ["src"]),
                  _createVNode("div", _hoisted_13, [
                    _createVNode("p", {
                      class: 
                `${
                  _ctx.cardActiveValidation(product.statusActive, product.isEmbargo)
                    ? 'text-gray-lp-600'
                    : 'text-gray-lp-800'
                } flex items-center`
              
                    }, [
                      _createVNode("span", _hoisted_14, _toDisplayString(_ctx.$t(_ctx.productTypeAsset(product.name).label)), 1),
                      (!_ctx.isEmbargo && product.statusActive && !product.isEmbargo)
                        ? (_openBlock(), _createBlock("span", _hoisted_15, [
                            _hoisted_16,
                            _createTextVNode(" " + _toDisplayString(product.estimateSla) + " " + _toDisplayString(_ctx.$t("bookingV3.productType.card.labelDay")), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 2),
                    (_ctx.isEmbargo || product.isEmbargo)
                      ? (_openBlock(), _createBlock("p", _hoisted_17, " Embargo "))
                      : (!product.statusActive)
                        ? (_openBlock(), _createBlock("p", _hoisted_18, _toDisplayString(_ctx.$t("bookingV3.productType.card.labelAvailable")), 1))
                        : (
                !_ctx.isEmbargo && product.statusActive && !product.isEmbargo
              )
                          ? (_openBlock(), _createBlock("p", _hoisted_19, _toDisplayString(_ctx.isFormBookClient || _ctx.isInternalAccount || product.isMasking
                  ? _ctx.maskingValue
                  : _ctx.formatEstimationPrice(`${product.shippingCost}`)), 1))
                          : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_20, [
                  _createVNode("p", {
                    class: 
              `${
                _ctx.cardActiveValidation(product.statusActive, product.isEmbargo)
                  ? 'text-gray-lp-600'
                  : 'text-gray-lp-800'
              }`
            
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t("bookingV3.productType.card.labelDiscountAgen")) + " ", 1),
                    (_ctx.discountAgentHide(product.statusActive, product.isEmbargo))
                      ? (_openBlock(), _createBlock("span", _hoisted_21, [
                          _hoisted_22
                        ]))
                      : (_openBlock(), _createBlock("b", _hoisted_23, _toDisplayString(_ctx.isFormBookClient || _ctx.isInternalAccount
                  ? "••%"
                  : _ctx.formatDiscountAgent(product.commissionRate)), 1))
                  ], 2),
                  _createVNode("strong", {
                    class: 
              `${
                _ctx.discountAgentValidation(product.statusActive, product.isEmbargo)
                  ? 'text-gray-lp-600'
                  : 'text-green-lp-400'
              }`
            
                  }, [
                    (_ctx.discountAgentHide(product.statusActive, product.isEmbargo))
                      ? (_openBlock(), _createBlock("div", _hoisted_24, [
                          _createTextVNode(_toDisplayString(_ctx.prefixCurrency) + " ", 1),
                          _createVNode("span", _hoisted_25, [
                            _createVNode("div", {
                              class: 
                    `dot rounded-full ${
                      _ctx.discountAgentValidation(
                        product.statusActive,
                        product.isEmbargo
                      )
                        ? 'bg-gray-lp-600'
                        : 'bg-green-lp-400'
                    }`
                  
                            }, null, 2),
                            _createVNode("div", {
                              class: 
                    `dot rounded-full ${
                      _ctx.discountAgentValidation(
                        product.statusActive,
                        product.isEmbargo
                      )
                        ? 'bg-gray-lp-600'
                        : 'bg-green-lp-400'
                    }`
                  
                            }, null, 2),
                            _createVNode("div", {
                              class: 
                    `dot rounded-full ${
                      _ctx.discountAgentValidation(
                        product.statusActive,
                        product.isEmbargo
                      )
                        ? 'bg-gray-lp-600'
                        : 'bg-green-lp-400'
                    }`
                  
                            }, null, 2),
                            _createVNode("div", {
                              class: 
                    `dot rounded-full ${
                      _ctx.discountAgentValidation(
                        product.statusActive,
                        product.isEmbargo
                      )
                        ? 'bg-gray-lp-600'
                        : 'bg-green-lp-400'
                    }`
                  
                            }, null, 2),
                            _createVNode("div", {
                              class: 
                    `dot rounded-full ${
                      _ctx.discountAgentValidation(
                        product.statusActive,
                        product.isEmbargo
                      )
                        ? 'bg-gray-lp-600'
                        : 'bg-green-lp-400'
                    }`
                  
                            }, null, 2),
                            _createVNode("div", {
                              class: 
                    `dot rounded-full ${
                      _ctx.discountAgentValidation(
                        product.statusActive,
                        product.isEmbargo
                      )
                        ? 'bg-gray-lp-600'
                        : 'bg-green-lp-400'
                    }`
                  
                            }, null, 2)
                          ])
                        ]))
                      : (_openBlock(), _createBlock("span", _hoisted_26, _toDisplayString(_ctx.isFormBookClient || _ctx.isInternalAccount
                  ? _ctx.maskingValue
                  : _ctx.formatEstimationPrice(`${product.bookingCommission}`)), 1))
                  ], 2)
                ]),
                (_openBlock(), _createBlock("svg", _hoisted_27, [
                  _createVNode("circle", {
                    cx: "61.0225",
                    cy: "-17.6784",
                    r: "44.917",
                    fill: 
              _ctx.isEmbargo || !product.statusActive || product.isEmbargo
                ? _ctx.productTypeAsset(product.name).colorInactive
                : _ctx.productTypeAsset(product.name).colorActive
            ,
                    "fill-opacity": "0.09"
                  }, null, 8, ["fill"]),
                  _createVNode("circle", {
                    cx: "61.4191",
                    cy: "-17.2819",
                    r: "61.0636",
                    fill: 
              _ctx.isEmbargo || !product.statusActive || product.isEmbargo
                ? _ctx.productTypeAsset(product.name).colorInactive
                : _ctx.productTypeAsset(product.name).colorActive
            ,
                    "fill-opacity": "0.08"
                  }, null, 8, ["fill"])
                ])),
                (_ctx.isNoRecommendation ? product.name === 'BOSSPACK' : product.isRecommended && _ctx.isBookingRetail)
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      class: 
            `${
              _ctx.isEmbargo || !product.statusActive || product.isEmbargo
                ? 'bg-gray-lp-1200'
                : 'bg-yellow-lp-1400'
            } rounded-br-sm rounded-bl-sm px-1 py-1.5 absolute top-0 right-5`
          ,
                      "aria-label": _ctx.$t('bookingV3.productType.card.labelRecommended')
                    }, [
                      _hoisted_28
                    ], 10, ["aria-label"]))
                  : _createCommentVNode("", true)
              ], 10, ["id", "onClick"]))
            }), 128))
          ]))
        : (!_ctx.isLoadingUpselling && _ctx.isErrorUpselling)
          ? (_openBlock(), _createBlock("div", _hoisted_29, [
              _createVNode("div", null, [
                _createVNode("div", _hoisted_30, [
                  _createVNode("p", _hoisted_31, _toDisplayString(_ctx.$t("bookingV3.productType.error.errorSystem.title")), 1),
                  _createVNode("p", _hoisted_32, _toDisplayString(_ctx.$t("bookingV3.productType.error.errorSystem.subtitle")), 1)
                ]),
                _createVNode("div", _hoisted_33, [
                  _createVNode("div", _hoisted_34, [
                    _createVNode(_component_lp_button, {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getProductType())),
                      title: _ctx.$t('bookingV3.productType.error.errorSystem.button'),
                      iconLeft: "refresh-white",
                      textColor: "white",
                      color: "red-lp-100"
                    }, null, 8, ["title"])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
    (!_ctx.isLoadingUpselling && _ctx.isErrorEstimation)
      ? (_openBlock(), _createBlock("div", _hoisted_35, [
          _createVNode(_component_Icons, {
            name: "warning-triangle",
            class: " w-4"
          }),
          _createVNode("p", _hoisted_36, _toDisplayString(_ctx.isErrorEstimation), 1)
        ]))
      : _createCommentVNode("", true)
  ], 6))
})